import type { SVGProps } from "react";
const SenecPictogramSolar = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M34.5429 5.04157C35.0723 5.1991 35.3737 5.75593 35.2161 6.28527C35.0757 6.75697 35 7.25766 35 7.7778C35 10.662 37.3381 13 40.2222 13C40.7424 13 41.243 12.9243 41.7148 12.7839C42.2441 12.6264 42.8009 12.9278 42.9585 13.4571C43.116 13.9864 42.8146 14.5433 42.2852 14.7008C41.6304 14.8957 40.9376 15 40.2222 15C36.2335 15 33 11.7665 33 7.7778C33 7.06243 33.1043 6.36966 33.2992 5.71477C33.4568 5.18543 34.0136 4.88403 34.5429 5.04157Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 17C6 15.3432 7.34315 14 9 14H23C23.5523 14 24 14.4477 24 15C24 15.5523 23.5523 16 23 16H20V21H26C26.5523 21 27 21.4477 27 22C27 22.5523 26.5523 23 26 23V28H30V24.5C30 23.9477 30.4477 23.5 31 23.5C31.5523 23.5 32 23.9477 32 24.5V28H38V34C38 35.6569 36.6569 37 35 37H25V41H29V43H15V41H19V37H9C7.34315 37 6 35.6569 6 34V17ZM21 37V41H23V37H21ZM24 35H20V30H24V35ZM26 35H30V30H26V35ZM32 30V35H35C35.5523 35 36 34.5523 36 34V30H32ZM24 28V23H20V28H24ZM18 28V23H14V28H18ZM12 30V31C12 31.5523 12.4477 32 13 32C13.5523 32 14 31.5523 14 31V30H18V35H9C8.44772 35 8 34.5523 8 34V30H12ZM12 28V23H8V28H12ZM8 21H12V16H9C8.44772 16 8 16.4477 8 17V21ZM14 16V21H18V16H14Z"
            fill="currentColor"
        />
        <path
            d="M26 7.00002C25.4477 7.00002 25 7.44773 25 8.00002C25 8.5523 25.4477 9.00002 26 9.00002H30C30.5523 9.00002 31 8.5523 31 8.00002C31 7.44773 30.5523 7.00002 30 7.00002H26Z"
            fill="currentColor"
        />
        <path
            d="M40 17C40.5523 17 41 17.4477 41 18V22C41 22.5523 40.5523 23 40 23C39.4477 23 39 22.5523 39 22V18C39 17.4477 39.4477 17 40 17Z"
            fill="currentColor"
        />
        <path
            d="M33.8184 15.596C34.209 15.2055 34.209 14.5724 33.8184 14.1818C33.4279 13.7913 32.7947 13.7913 32.4042 14.1818L29.7376 16.8485C29.347 17.239 29.347 17.8722 29.7376 18.2627C30.1281 18.6532 30.7612 18.6532 31.1518 18.2627L33.8184 15.596Z"
            fill="currentColor"
        />
        <path
            d="M31.9561 11.1068C32.1675 11.6171 31.9252 12.202 31.4149 12.4134L27.3044 14.116C26.7941 14.3274 26.2091 14.0851 25.9978 13.5749C25.7864 13.0646 26.0287 12.4796 26.539 12.2683L30.6495 10.5656C31.1598 10.3543 31.7448 10.5966 31.9561 11.1068Z"
            fill="currentColor"
        />
        <path
            d="M35.7323 21.461L37.4512 17.3112C37.6626 16.8009 37.4203 16.216 36.91 16.0046C36.3998 15.7933 35.8148 16.0356 35.6035 16.5458L33.8846 20.6956C33.6732 21.2059 33.9155 21.7908 34.4257 22.0022C34.936 22.2135 35.521 21.9712 35.7323 21.461Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramSolar;
